// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import AuthService from 'services/authServices';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FBS_API_KEY,
  // authDomain: process.env.REACT_APP_FBS_AUTH,
  projectId: process.env.REACT_APP_FBS_ID,
  // storageBucket: process.env.REACT_APP_FBS_STRG,
  messagingSenderId: process.env.REACT_APP_FBS_MSG_ID,
  appId: process.env.REACT_APP_FBS_APP_ID
  // measurementId: process.env.REACT_APP_FBS_MSR_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

const messaging = getMessaging(app);

/**
 * This function requests permission for notifications from Firebase messaging API.
 * It returns a Promise that resolves with the Firebase notification
 * token if permission is granted,
 * or rejects with an error if the request fails or is denied.
 */
export const requestFirebaseNotificationPermission = () =>
  new Promise((resolve, reject) => {
    messaging
      .requestPermission()
      .then(() => messaging.getToken())
      .then((firebaseToken) => {
        resolve(firebaseToken);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const requestForToken = () => {
  // The method getToken(): Promise<string> allows FCM to use the VAPID key credential
  // when sending message requests to different push services
  return getToken(messaging, { vapidKey: process.env.REACT_APP_FBS_VAPID_KEY }) //to authorize send requests to supported web push services
    .then((currentToken) => {
      console.log(currentToken);
      if (currentToken) {
        console.log('current token for client: ', currentToken);

        if (localStorage.getItem('fcmToken') && currentToken !== localStorage.getItem('fcmToken')) {
          localStorage.setItem('fcmToken', currentToken);
        } else if (!localStorage.getItem('fcmToken')) {
          localStorage.setItem('fcmToken', currentToken);
        }

        AuthService.setFcmToken({ token: currentToken });
      } else {
        console.log('No registration token available. Request permission to generate one.');
        Notification.requestPermission().then((permission) => {
          requestForToken()
          console.log('Access for notification is ', permission);
        });
      }
    })
    .catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
    });
};

// Handle incoming messages. Called when:
// - a message is received while the app has focus
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
